module.exports = __webpack_public_path__ + "img/list_box_top_bg.2978174f.png";